"use strict";
exports.__esModule = true;
var ramda_1 = require("ramda");
var utils_1 = require("../utils");
var generateAppConfig = function (user) {
    var config = {};
    var scopes = user.scopes, gates = user.gates;
    var isVideoUserOnly = utils_1.getIsVideoUserOnly(scopes);
    var isCalendarUser = utils_1.getIsCalendarUser(scopes, gates);
    var isBotsV2User = utils_1.getIsBotsV2User(gates);
    var hasSavedReplies = !!gates.saved_replies;
    var isPaidPlan = !!gates.premium_drift || !!gates.premium_team || !!gates.premium_enterprise;
    var isOrgAdmin = utils_1.getIsOrgAdmin(scopes);
    var hasBulkClose = isOrgAdmin && !!gates.beta_bulk_close;
    /*** My settings ***/
    if (isBotsV2User || isVideoUserOnly) {
        config = ramda_1.set(ramda_1.lensProp('hasProfile'), false, config);
        config = ramda_1.set(ramda_1.lensProp('hasDriftAssistant'), false, config);
    }
    else {
        config = ramda_1.set(ramda_1.lensProp('hasProfile'), true, config);
        config = ramda_1.set(ramda_1.lensProp('hasDriftAssistant'), true, config);
    }
    if (isVideoUserOnly || isCalendarUser || isBotsV2User) {
        config = ramda_1.set(ramda_1.lensProp('hasNotifications'), false, config);
        config = ramda_1.set(ramda_1.lensProp('hasEmail'), false, config);
    }
    else {
        config = ramda_1.set(ramda_1.lensProp('hasNotifications'), true, config);
        config = ramda_1.set(ramda_1.lensProp('hasEmail'), true, config);
    }
    if (isVideoUserOnly) {
        config = ramda_1.set(ramda_1.lensProp('hasMeetings'), false, config);
    }
    else {
        config = ramda_1.set(ramda_1.lensProp('hasMeetings'), !isBotsV2User, config);
    }
    /*** Organization settings ***/
    config = ramda_1.set(ramda_1.lensProp('hasBilling'), !isBotsV2User, config);
    config = ramda_1.set(ramda_1.lensProp('hasManageTeammates'), !isBotsV2User, config);
    config = ramda_1.set(ramda_1.lensProp('hasTeams'), !isBotsV2User, config);
    config = ramda_1.set(ramda_1.lensProp('hasDataPrivacy'), !isBotsV2User, config);
    config = ramda_1.set(ramda_1.lensProp('hasSecurity'), !isBotsV2User, config);
    /*** App settings ***/
    config = ramda_1.set(ramda_1.lensProp('hasWidget'), !isBotsV2User, config);
    config = ramda_1.set(ramda_1.lensProp('hasConvoRouting'), !isBotsV2User, config);
    config = ramda_1.set(ramda_1.lensProp('hasBot'), !isBotsV2User, config);
    /*** Conversation settings ***/
    if (isBotsV2User) {
        config = ramda_1.set(ramda_1.lensProp('hasSavedReplies'), false, config);
        config = ramda_1.set(ramda_1.lensProp('hasEmailSendingDomains'), true, config);
        config = ramda_1.set(ramda_1.lensProp('hasBulkClose'), false, config);
    }
    else {
        config = ramda_1.set(ramda_1.lensProp('hasSavedReplies'), hasSavedReplies, config);
        config = ramda_1.set(ramda_1.lensProp('hasEmailSendingDomains'), isPaidPlan, config);
        config = ramda_1.set(ramda_1.lensProp('hasBulkClose'), hasBulkClose, config);
    }
    config = ramda_1.set(ramda_1.lensProp('hasTags'), !isBotsV2User, config);
    config = ramda_1.set(ramda_1.lensProp('hasEmailPreferencesLink'), !isBotsV2User, config);
    config = ramda_1.set(ramda_1.lensProp('hasInboxes'), !isBotsV2User, config);
    config = ramda_1.set(ramda_1.lensProp('hasAdvanced'), !isBotsV2User, config);
    return config;
};
exports["default"] = generateAppConfig;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@driftt/app-config/dist/appConfigs/settingsWeb/index.js
// module id = PNQJ
// module chunks = 88